import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "input"]

  connect() {
    // Stop loading controller if no button on turbo re render
    if (!this.hasButtonTarget) {
      return
    }
    const isEnabled = this.inputTarget.value === "true"
    this.buttonTarget.classList.toggle("active", isEnabled)

    this.updateTooltip()
  }

  toggle() {
    const isEnabled = this.inputTarget.value === "true"
    this.inputTarget.value = (!isEnabled).toString()

    // Dispatch change event for listeners
    this.inputTarget.dispatchEvent(new Event("change"))

    this.buttonTarget.classList.toggle("active", !isEnabled)

    this.updateTooltip()
  }

  updateTooltip() {
    $(this.buttonTarget).tooltip('dispose').tooltip()
  }
}
